import React from 'react';
import ReactDOM from 'react-dom';

import App from './Routes';

import installGainsightPX from './utils/gainsightpx';
import { getMetaOptions, httpOptions, clientUrl } from '@dm/components';

import { polyfill } from '@dm/scripts';

polyfill();

const options = getMetaOptions();
httpOptions.setHeaders(options);
clientUrl.setSessionParams(
	options.httpSessionAliasParamName,
	options.httpSessionAlias
);

installGainsightPX(options);

function renderReact() {
	const root =
		document.getElementById('react-root') ||
		document.getElementById('react-root--legacy');
	if (root) {
		ReactDOM.render(<App metadata={options} />, root);
	}
	document.removeEventListener('DOMContentLoaded', renderReact);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', renderReact);
} else {
	renderReact();
}
